// worked so perfectly
import React, { useState, useRef  } from 'react';
import { Button, TextField, Container, Typography, Box, CircularProgress } from '@mui/material'; 
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import api from '../utils/axiosInstance';
import { toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const apiUrl = process.env.REACT_APP_API_URL;
  const siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

  // added from chatgpt
  const recaptchaRef = useRef(null); // Reference for the ReCAPTCHA component

  const handleCaptchaChange = (token) => {
    // console.log("reCAPTCHA Token:", value);
    setCaptchaToken(token); // Store the CAPTCHA token
  };
  
  // Pure function to handle the form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // added this from chatgpt to add captcha
    if (!email) {
      toast.error("Email is required");
      return;
    } else if (!captchaToken) { // Check for reCAPTCHA verification
      toast.error("Please complete the reCAPTCHA verification.");
      return;
    }
    
    // original code
    else if (email) {
      setLoading(true); // Set loading to true when request starts

      try {
        const res = await api.post(
          // "/auth/password-reset/", { email }
          `${apiUrl}/api/v1/auth/password-reset/`, { 
            email,
            recaptcha_token: captchaToken, 
          }
        );

        if (res.status === 200) {
          // added from chatgpt
          if (recaptchaRef.current) {
            recaptchaRef.current.reset();
          }
          // Assuming the backend sends a message with the success response
          toast.success(res.data.message || "A link to reset your password has been sent to your email address");
        }
        setEmail(""); // Reset email field
        // added from chatgpt
        setCaptchaToken(null); // Clear the captcha token
      } catch (error) {
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        // Check if the error has a response from the backend
        if (error.response && error.response.data) {
          const errData = error.response.data;

          // Check if error is a list of validation errors
          const errorMessage = typeof errData === 'object' ? Object.values(errData).flat().join(", ") : errData;

          // Display the correct backend error message
          toast.error(errorMessage || "An error occurred. Please try again.");
        } else {
          toast.error("An unexpected error occurred. Please try again.");
        }
      } finally {
        setLoading(false); // Set loading to false once the request is completed
      }
    }
  };

  return (
    <>
      <Header />
      {/* <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
        <HomeIcon fontSize="large" />
        <Typography variant="h4" ml={1}>
          Enter Your Registered Email
        </Typography>
      </Box> */}
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        mt={3} 
        mb={2}
        sx={(theme) => ({
          flexDirection: 'row', // Default layout
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column', // Stack items vertically on mobile
            mt: 2, // Reduce margin-top
            mb: 1, // Reduce margin-bottom
          },
        })}
      >
        <HomeIcon 
          fontSize="large" 
          sx={(theme) => ({
            fontSize: '2.5rem', // Default size
            [theme.breakpoints.down('sm')]: {
              fontSize: '2rem', // Smaller icon size on mobile
            },
          })}
        />
        <Typography 
          variant="h4" 
          ml={1}
          sx={(theme) => ({
            fontSize: '2rem', // Default font size
            ml: 1, // Default margin-left
            [theme.breakpoints.down('sm')]: {
              fontSize: '1.5rem', // Smaller font size on mobile
              ml: 0, // Remove margin-left on mobile
              textAlign: 'center', // Center text
            },
          })}
        >
          Enter Your Registered Email
        </Typography>
      </Box>

      <Container maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            margin="normal"
            fullWidth
            required
            disabled={loading} // Disable input while loading
          />
          <Box display="flex" justifyContent="center" mt={2}>
            <ReCAPTCHA
              // added from chatgpt
              ref={recaptchaRef} // Add reference to the ReCAPTCHA instance
              sitekey={siteKey}
              // onChange={(token) => setCaptchaToken(token)}
              onChange={handleCaptchaChange}
            />
          </Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              mt: 2,
              py: { xs: 1, sm: 1.5 }, // Adjust padding for button
              fontSize: { xs: '0.875rem', sm: '1rem' } // Adjust font size for button text
            }}
            disabled={loading} // Disable button while loading
            startIcon={loading && <CircularProgress size={20} />} // Show loader inside the button
          >
            {loading ? 'Sending...' : 'Send'}
          </Button>
        </form>
      </Container>
    </>
  );
}

export default ForgotPassword;

// import React, { useState } from 'react';
// import { Button, TextField, Container, Typography, Box, CircularProgress } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import api from '../utils/axiosInstance';
// import { toast } from 'react-toastify';

// function ForgotPassword() {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false); // Loading state

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (email) {
//       setLoading(true); // Set loading to true when request starts
//       try {
//         const res = await api.post("/auth/password-reset/", { email });
        
//         if (res.status === 200) {
//           // Assuming the backend sends a message with the success response
//           toast.success(res.data.message || "A link to reset your password has been sent to your email address");
//         }
//         setEmail(""); // Reset email field
//       } catch (error) {
//         // Check if the error has a response from the backend
//         if (error.response && error.response.data) {
//           toast.error(error.response.data.message || "An error occurred. Please try again.");
//         } else {
//           toast.error("An unexpected error occurred. Please try again.");
//         }
//       } finally {
//         setLoading(false); // Set loading to false once the request is completed
//       }
//     }
//   };

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Enter Your Registered Email
//         </Typography>
//       </Box>
//       <Container maxWidth="sm">
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Email"
//             name="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//             disabled={loading} // Disable input while loading
//           />
//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             disabled={loading} // Disable button while loading
//             startIcon={loading && <CircularProgress size={20} />} // Show loader inside the button
//           >
//             {loading ? 'Sending...' : 'Send'}
//           </Button>
//         </form>
//       </Container>
//     </>
//   );
// }

// export default ForgotPassword;

// worked well but does not display backend error
// import React, {useState} from 'react';
// import { Button, TextField, Container, Typography, Box, CircularProgress } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import api from '../utils/axiosInstance';
// import { toast } from 'react-toastify';

// function ForgotPassword() {
//   const [email, setEmail] = useState("")

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (email) {
//       try {
//         const res = await api.post("/auth/password-reset/", { email });
        
//         if (res.status === 200) {
//           // Assuming the backend sends a message with the success response
//           toast.success(res.data.message || "A link to reset your password has been sent to your email address");
//         }
//         setEmail("");
//       } catch (error) {
//         // Check if the error has a response from the backend
//         if (error.response && error.response.data) {
//           toast.error(error.response.data.message || "An error occurred. Please try again.");
//         } else {
//           toast.error("An unexpected error occurred. Please try again.");
//         }
//       }
//     }
//   };

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Enter Your Registered Email
//         </Typography>
//       </Box>
//       <Container maxWidth="sm">
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Email"
//             name="email"
//             value={email}
//             onChange={(e)=>setEmail(e.target.value)}
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <Button type="submit" variant="contained" color="primary" fullWidth>
//             Send
//           </Button>
//         </form>
//       </Container>
//     </>
//   );
// }

// export default ForgotPassword
